import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EndpointService {
  constructor() { }
  apiUrl = environment.apiurl + "/auth";
  public loginUrl(): string {
    return `${this.apiUrl}/signin`;
  }

  public isExits(): string {
    return `${this.apiUrl}/user/exits`;
  }

  public isOrganizationExits(): string {
    return `${this.apiUrl}/organization/_exits`
  }

  public getUserProfilePreference(server: string): string {
    return `${server}/profile/get-user-pref`;
  }

  public switchTenantUrl(): string {
    return `${this.apiUrl}/switch-tenant`;
  }

  public regionsList() : string {
    return `${this.apiUrl}/regions/_list`;
  }

  public registerOrganization() {
    return `${this.apiUrl}/save-org-details`;
  }

  public checkSignupEmail() {
    return `${this.apiUrl}/trigger/email/confirmation`;
  }

  public validateSignUpLink() {
    return `${this.apiUrl}/org/registration/validate`;
  }

  public resetPasswordSendEmailUrl(): string {
    return `${this.apiUrl}/trigger/email/password/reset`;
  }

  public validateResetPassword(): string {
    return `${this.apiUrl}/validate/reset/password`;
  }

  public resetPasswordUrl(): string {
    return `${this.apiUrl}/reset-password`;
  }

  public continueRegistrationUrl(host: string): string {
    return `${host}/profile/continue-registration/V2`;
  }

  public sendEmailToAdmin(): string {
    return `${this.apiUrl}/trigger/notif/confirmation`;
  }

  public createNewUser(endpoint: string): string {
    return `${endpoint}/profile/saml/create/user`
  }

  public jwtRefresh(): string {
    return this.apiUrl + '/refresh';
  }

  public createNewTenantSchema(host: string): string {
    return `${host}/profile/org/tenant/_create`;
  }

  public inviteUserUpdatePassword(): string {
    return `${this.apiUrl}/save-user-info/V2`;
  }

  public updateStatusMembersUrl( server: string, updateAll: boolean, updateType: string, tenantId: string, invitationDto?: string): string {
    return `${server}/profile/updateStatus?updateAll=${updateAll}&updateType=${updateType}&tenantId=${tenantId}&invitationDto=${invitationDto}`;
  }

  /**
   * Returns `[[API-DOMAIN]]/profile/verify` endpoint
   */
  public validateURL(server: string): string {
    return `${server}/profile/verify`;
  }

  /**
   * C login || cross login url
   * @returns will return the url for cross login ..
   */
  public cLoginUrl(): string {
    return `${this.apiUrl}/c/login`;
  }

  public syncPersonalDetails(server: string): string {
    return `${server}/profile/sync-personal-details`;
  }

  /**
   * To resend the email to newly onboarded user
   * @param server redirectUrl
   * @returns
   */
  public resendEmail(server: string): string {
    return `${server}/profile/resend-activation`;
  }

  public getOrganisation(searchString, size, page) {
     return `${this.apiUrl}/organization/_all?searchString=${searchString}&size=${size}&page=${page}`
  }

  public getTenantList(orgId: string) {
    return `${this.apiUrl}/tenant/getTenantsByOrgId/${orgId}`
  }

  public getTenantListV2(orgId: string) {
    return `${this.apiUrl}/v1.0/admin/manage/feature/tenant?orgId=${orgId}`
  }

  public getTenantFeatures() {
    return `${this.apiUrl}/v1.0/admin/manage/feature`
  }

  public createFeatureFlag(tenantId) {
    return `${this.apiUrl}/v1.0/admin/manage/feature/flag?tenantId=${tenantId}`;
  }

public updateFeatureFlag(tenantId) {
  return `${this.apiUrl}/v1.0/admin/manage/feature/flag?tenantId=${tenantId}`;
}

public checkFeatureFlag(featureFlag) {
  return `${this.apiUrl}/v1.0/admin/manage/feature/flag?feature=${featureFlag}`;
}

  public syncDetailsForManualUserCreation(server: string): string {
    return `${server}/profile/sync-personal-details-v2`;
  }
}
